import ProviderIcon from '../../../../../icons/provider.svg'

export function getProviderItemProps(item) {
  return {
    Icon: ProviderIcon,
    isArchived: item.archived,
    value: item,
  }
}
